import GoodsImport from "@/components/goods/goodsImport/goodsImport";
import ImportList from "@/components/goods/importList/importList";
import GoodsHandler from "@/components/goods/handler/Handler";
import Category from "@/components/goods/category/Category";
import GoodsAdd from "@/components/goods/add/GoodsAdd";
import GoodsExport from "@/components/goods/export/Export";
import GoodEdit from "@/components/goods/edit/Edit";
import GoodsDelete from "@/components/goods/delete/GoodsDelete.vue";
import GoodsMassChange from "@/components/goods/massСhange/MassChange.vue"
import CategoriesExport from "@/components/goods/categoriesExport/CategoriesExport.vue";
import CategoryMatching from "@/components/goods/categoryMatching/CategoryMatching.vue";

export const goodsImport = [
    {path: '/goods-category', name: 'goodsCategory', component: Category},
    {path: '/goods-import', name: 'goodsImport', component: GoodsImport},
    {path: '/goodsimport-list', name: 'goodsImportList', component: ImportList},
    {path: '/goods-handler', name: 'product', component: GoodsHandler},
    {path: '/goods-add', name: 'goodsAdd', component: GoodsAdd},
    {path: '/goods-export', name: 'goodsExport', component: GoodsExport},
    {path: '/goods-edit/:id', name: 'goodEdit', component: GoodEdit},
    {path: '/goods-delete', name: 'goodsDelete', component: GoodsDelete},
    {path: '/goods-change', name: 'GoodsMassChange', component: GoodsMassChange},
    {path: '/categories-export', name: 'CategoriesExport', component: CategoriesExport},
    {path: '/category-matching', name: 'CategoryMatching', component: CategoryMatching},
]